import React from 'react';
import { Toaster } from '@/components/ui';
import { EnhancedAppHeader } from '../EnhancedAppHeader';
import { PortalFooter } from '../PortalLayout/PortalFooter';

interface AnonymousPortalLayoutProps {
  children: React.ReactNode;
  mainClassName?: string;
}

export const AnonymousPortalLayout = React.forwardRef<HTMLDivElement, AnonymousPortalLayoutProps>(
  ({ children, mainClassName = 'flex-1 flex items-center justify-center py-8 px-4 sm:px-6' }, ref) => (
    <div ref={ref} className="min-h-screen bg-white flex flex-col">
      <EnhancedAppHeader />
      <main className={mainClassName}>
        {children}
      </main>
      <div className="border-t border-gray-200 px-4 sm:px-6 lg:px-10">
        <PortalFooter />
      </div>
      <Toaster />
    </div>
  )
);

AnonymousPortalLayout.displayName = 'AnonymousPortalLayout';
